import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { notify } from "../../../utils/shared";

const API_URL = process.env.REACT_APP_API_URL;
const GET_VIRTUAL_ACCOUNTS = `${API_URL}/virtual-accounts`;
const ADD_VIRTUAL_ACCOUNT = `${API_URL}/virtual-accounts`;
const UPDATE_VIRTUAL_ACCOUNT = `${API_URL}/virtual-accounts`;
const DELETE_VIRTUAL_ACCOUNT = `${API_URL}/virtual-accounts`;

export interface VirtualAccountRole {
  _id: string;
  name: string;
  slug: string;
}

export interface VirtualAccount {
  id?: string | number;
  account?: string;
  parent: number;
  roleId?: string | null;
  role?: VirtualAccountRole | null;
  firstName?: string;
  lastName?: string;
  title?: string;
  password?: string;
  confirmPassword?: string;
}

export const getVirtualAccounts = createAsyncThunk(
  "getVirtualAccounts",
  async (params: { page?: number; limit?: number; search?: string; account?: string }, { rejectWithValue }) => {
    try {
      let user: any = localStorage.getItem('kt-auth-react-v');
      user = JSON.parse(user);
      const { data } = await axios.get(GET_VIRTUAL_ACCOUNTS, {
        headers: { authorization: user.token },
        params
      });
      return data;
    } catch (error: any) {
      console.log('error virtual', error);
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const addVirtualAccount = createAsyncThunk(
  "addVirtualAccount",
  async (values: VirtualAccount, { rejectWithValue }) => {
    try {
      let user: any = localStorage.getItem('kt-auth-react-v');
      user = JSON.parse(user);
      const { data } = await axios.post(ADD_VIRTUAL_ACCOUNT, values, {
        headers: { authorization: user.token }
      });
      notify(data.responseMessage || 'Team member created successfully', 'success');
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const updateVirtualAccount = createAsyncThunk(
  "updateVirtualAccount",
  async (values: VirtualAccount, { rejectWithValue }) => {
    try {
      let user: any = localStorage.getItem('kt-auth-react-v');
      user = JSON.parse(user);
      const { data } = await axios.put(UPDATE_VIRTUAL_ACCOUNT, values, {
        headers: { authorization: user.token }
      });
      notify(data.responseMessage || 'Team member updated successfully', 'success');
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const deleteVirtualAccount = createAsyncThunk(
  "deleteVirtualAccount",
  async (
    { id, parent, account }: { id: string | number; parent: number; account?: string },
    { rejectWithValue }
  ) => {
    try {
      let user: any = localStorage.getItem('kt-auth-react-v');
      user = JSON.parse(user);
      const { data } = await axios.post(
        `${DELETE_VIRTUAL_ACCOUNT}/delete`,
        { id, parent, account },
        {
          headers: { authorization: user.token },
        }
      );
      notify(data.responseMessage || 'Team member deleted successfully', 'success');
      return id;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);
